import { sessionManager } from '@onviobr/security-services';
import { Subject, merge } from 'rxjs';
import { filter, map, shareReplay, switchMap } from 'rxjs/operators';
import { isTestEnv } from '@onviobr/helpers';
import { getUserProfileV1, updateProfileLanguage } from './profile-services.js';
/**
 * Creates a Profile Manager
 * @public
 */
export class ProfileManager {
    constructor(session) {
        /**
         * Internal {@link rxjs#Subject} used to trigger updates of the profile
         */
        this.updater = new Subject();
        /* istanbul ignore next: during testing no default managers will be used */
        this.session = session !== null && session !== void 0 ? session : sessionManager;
        // Regardless if the session bindings changes or an updates happens, the Profile will be updated
        this.currentProfile = merge(this.session.authenticated, this.updater).pipe(filter(authenticated => authenticated), switchMap(() => getUserProfileV1(this.session)), shareReplay(1));
        this.currentLanguage = this.currentProfile.pipe(map(s => s.language));
    }
    async updateProfileLanguage(language) {
        await updateProfileLanguage(this.session, language);
        // Tells the manager that should update
        this.updater.next(true);
    }
    dispose() {
        this.updater.complete();
    }
}
/**
 * Default instance of {@link ProfileManager}
 * @remarks It will be `undefined` during testing executions to avoid unexpected network requests
 */
/* istanbul ignore next: during testing no default managers will be used */
ProfileManager.root = isTestEnv() ? undefined : new ProfileManager();
/**
 * Default {@link ProfileManager} instance
 * @public
 * @remarks It will be `undefined` during testing executions to avoid unexpected network requests
 */
export const profileManager = ProfileManager.root;
